import { getlangStorage, setLocDatFinStorage } from "../../../context/utils";
import { Logout } from "../../../services/UserAuthService";
import * as FaIcons from "react-icons/fa";
import { format } from "date-fns";
import { GetDatePartCurrent, getDefaultAudience } from "../../../utils/dateHelper";
import {
  ChannelDataOrder,
  IDateTimeAudienceCountry,
} from "../../../context/types";
import { IChannelDataIconOption } from "../../../utils/types";
import { DivMinuteEnum } from '../../../utils/enums';
import { usePreference } from "../../../context/usePreference";

export async function handleLogOutApi(token) {
  try {
    
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { userPreference } = usePreference();
    await Logout(token, userPreference)
      .then((res) => { })
      .catch((err) => { });
  } catch (error) {
    throw new Error("Erro ao fazer logout.");
  }
}
export function handlingLocDatIni(
  LocDatIniStorage: string | null,
  DtIni: Date,
  DtFin: Date,
  HorIni: string | null,
  user: any,
  dateTimeAudienceData: IDateTimeAudienceCountry | undefined
) {
  let currentDate = new Date();
  if (LocDatIniStorage !== null && LocDatIniStorage !== "") {
    let hrIni = LocDatIniStorage.split("T")[1].substring(0, 5);
    DtIni.setHours(
      parseInt(hrIni.split(":")[0]),
      parseInt(hrIni.split(":")[1]),
      0
    );
    HorIni = format(DtIni, "yyyy-MM-dd'T'HH:mm:ss");

    if (DtIni < new Date()) {
      HorIni = format(DtIni, "yyyy-MM-dd'T'HH:mm:ss");
      user.userPreference.HorarioIni = LocDatIniStorage;
    } else {
      let dataTimeDefault = getDefaultAudience(dateTimeAudienceData);//IBOPE HOUR
      currentDate.setHours(
        dataTimeDefault.hoursDefaultIni,
        dataTimeDefault.minutesDefaultIni,
        dataTimeDefault.secondsDefaultIni
      );
      HorIni = format(currentDate, "yyyy-MM-dd'T'HH:mm:ss");
      user.userPreference.HorarioIni = HorIni;
    }
  }
  let resultDT = { LocDatIniStorage, DtIni, HorIni, user };
  return resultDT;
}
export function handlingLocDatFin(
  LocDatFinStorage: string | null,
  DtFin: Date,
  DefDate: Date,
  HorFin: string | null,
  user: any
) {
  if (LocDatFinStorage != null && LocDatFinStorage !== "") {
    let hrFin = LocDatFinStorage.split("T")[1].substring(0, 5);
    DtFin.setHours(
      parseInt(hrFin.split(":")[0]),
      parseInt(hrFin.split(":")[1])
    );
    if (DtFin < DefDate) {
      HorFin = format(DtFin, "yyyy-MM-dd'T'HH:mm:ss");
    }
  } else {
    let hrFin = user?.userPreference?.Horario?.split("T")[1].substring(0, 5);
    DtFin.setHours(
      parseInt(hrFin.split(":")[0]),
      parseInt(hrFin.split(":")[1])
    );
    if (DtFin > DefDate) {
      HorFin = format(DefDate, "yyyy-MM-dd'T'HH:mm:ss");
    }
  }
  return { LocDatFinStorage, DtFin, DefDate, HorFin, user };
}
export function getDateFormat(selectedDate: Date | undefined) {
  return format(
    selectedDate !== undefined ? new Date(selectedDate.toString()) : new Date(),
    "yyyy-MM-dd"
  );
}
export function getDateForChangeMinute(userPreference, minuteSelect): Date {
  let date = new Date(userPreference?.Data);
  if (minuteSelect === undefined) {
    date.setHours(
      userPreference?.Horario?.split("T")[1].split(":")[0],
      userPreference?.Horario?.split("T")[1].split(":")[1]
    );
  } else {
    date.setHours(minuteSelect.split(":")[0]);
    date.setMinutes(minuteSelect.split(":")[1]);
  }

  return date;
}
export function validUserPreference(userPreference): boolean {
  return userPreference !== undefined && userPreference !== null;
}

export function getDateForChangeMinuteIni(
  userPreference,
  minuteIniSelect
): Date {
  let date = new Date(userPreference.Data);
  if (minuteIniSelect === undefined) {
    let dtIniHour = userPreference.HorarioIni.split("T")[1].split(":")[0];
    let dtIniMin = userPreference.HorarioIni.split("T")[1].split(":")[1];
    date.setHours(dtIniHour, dtIniMin);
  } else {
    date.setHours(minuteIniSelect.split(":")[0]);
    date.setMinutes(minuteIniSelect.split(":")[1]);
  }
  return date;
}

export function validAudienceData(audience: any): boolean {
  return audience !== undefined && audience !== null;
}
export function getMsgPopError(dataMsg: string | null): string {
  return dataMsg ?? "";
}

export function loadHoursCalendar(): string[] {
  let startHours: string[] = [];
  for (let h = 0; h < 24; h++) {
    startHours.push(h < 10 ? "0" + h : h.toString());
  }
  return startHours;
}
export function loadMinutesCalendar(): string[] {
  let minutes: string[] = [];
  for (let m = 0; m < 60; m++) {
    minutes.push(m < 10 ? "0" + m : m.toString());
  }
  return minutes;
}

export function getPracaTargets(praca, userPreference): any {
  let pracaTargets;
  if (praca !== undefined && praca.length > 0) {
    pracaTargets = praca?.filter(function (el) {
      return el.Id === userPreference?.Praca?.Id;
    })[0];
  }
  return pracaTargets;
}

export function validTipoBase(userPreference: any, tipoBase: number): boolean {
  return userPreference?.TipoBase !== tipoBase;
}

export function getPracaAbrev(
  selectedPracaAbrev: string | undefined,
  userPreference: any
): React.ReactNode {
  return selectedPracaAbrev ?? userPreference?.Praca?.Abrev;
}

export function useClassNameSelectedTarget(): string | undefined {
  const { userPreference, userTarget } = usePreference();

  let targetId = userTarget?.Target?.Id;
  const Target = userPreference.Praca?.Targets?.find(
    (target) => target.Id === targetId
  ) ?? userPreference.Praca?.Targets?.[0];

  return `target-${Target.Id}`;
  
}

export function getTargetId(userPreference: any, pracaEncontrada: any) {
  if (userPreference.Target && pracaEncontrada?.Targets.some((t: any) => t.Id === userPreference.Target.Id)) {
    return userPreference.Target.Id;
  }
  return pracaEncontrada?.Targets[0]?.Id ?? userPreference.Praca.Targets[0]?.Id;
}

export function getClassNameSidebarMenu(sidebar: string): string {
  return sidebar === "menu" ? "nav-menu" : "nav-menu-hidden";
}
export function getClassNameSidebarMenuItens(sidebar: string): string {
  return sidebar ? "nav-menu-items" : "nav-menu-other";
}
export function getClassNameSidebarMenuNav(
  sidebar: string,
  valueCondition: string
): string {
  return sidebar === valueCondition ? "nav-menu" : "nav-menu-hidden";
}
export function getClassNameNavTarget(
  sidebar: string,
  valueCondition: string
): string {
  return sidebar === valueCondition ? "nav-target" : "nav-menu-hidden";
}
export function getClassNameNavPrint(
  sidebar: string,
  valueCondition: string
): string {
  return sidebar === valueCondition ? "nav-print" : "nav-menu-hidden";
}
export function getClassNameNavMenuIcon(
  valueCriteria: any,
  valueConditionChecked: any
): string {
  return valueCriteria === valueConditionChecked
    ? "iconChecked"
    : "nav-menu-hidden";
}
export function getSideIconByLanguage(): string | null {
  return getlangStorage() === null ? "pt-BR" : getlangStorage();
}

export function isInValidSelectedDate(selectedDate: Date | undefined): boolean {
  return selectedDate === undefined;
}

export function validDisableBotton(
  expresssionCriateria: any,
  expresssionCriateriaSecond: any
): boolean {
  let result: boolean = expresssionCriateria === 1;

  if ((result && expresssionCriateriaSecond) || result) {
    result = false;
  } else if ((!result && expresssionCriateriaSecond)) {
    result = true;
  }

  return result;
}
export function getLabelHour(
  DivMinute: number,
  HoraIni: any,
  HoraFin: any
): React.ReactNode {
  return DivMinute === DivMinuteEnum.Media ? HoraIni + " - " + HoraFin : HoraFin;
}

export function getClassNamePeriodicidade(
  userPreference: any,
  periodoId: any
): string {
  return userPreference?.Periodicidade.Id === periodoId
    ? ""
    : "nav-menu-hidden";
}

export function renderIconPeridoInicial(Ordenacao: any) {
  return Ordenacao === 0 ? (
    <i className="icon_symbol  iconPeridoInicial">d</i>
  ) : (
    <i className="icon_symbol  iconPeridoFinal">c</i>
  );
}

export function renderFaIconsFaChevronUpForHoraOrHoraMedia(sidebar: string) {
  return sidebar === "hora" || sidebar === "hora_media" ? (
    <FaIcons.FaChevronUp />
  ) : (
    <FaIcons.FaChevronDown />
  );
}

export function renderFaIconsFaChevronUp(sidebar: string, criteria: string) {
  return sidebar === criteria ? (
    <FaIcons.FaChevronUp />
  ) : (
    <FaIcons.FaChevronDown />
  );
}
export function getstylepracatextnav(
  PracaCor: any
): React.CSSProperties | undefined {
  return { fontWeight: PracaCor != null ? "bold" : "" };
}

export function getHorarioIni(
  isAutoUpdate: boolean,
  horarioIni: Date,
  horarioFinal: Date,
  dateTimeAudienceData: IDateTimeAudienceCountry | undefined
): Date {
  let horarioIniResult: Date = horarioIni;
  let dataTimeDefault = getDefaultAudience(dateTimeAudienceData);
  if (isAutoUpdate === false && horarioIni > horarioFinal) {
    //IBOPE HOUR
    horarioIniResult.setHours(
      dataTimeDefault.hoursDefaultIni,
      dataTimeDefault.minutesDefaultIni,
      dataTimeDefault.secondsDefaultIni
    );
  }
  return horarioIniResult;
}

export function getHoraForSetState(horario: string): string {
  if (horario.search("T") < 0) return horario;
  return horario?.split("T")[1].substring(0, 5) ?? "";
}

export class ObjDataDTO {
  public DataValueArray: any;
  public ValueId: number;
  constructor(value, valueId) {
    this.DataValueArray = value;
    this.ValueId = valueId;
  }
}

export function getDataObjArray(dataObj: any): ObjDataDTO[] {
  const rowDatas: ObjDataDTO[] = [];
  dataObj?.map((val, valId) => {
    rowDatas.push({ DataValueArray: val, ValueId: Number(valId) });
  });
  return rowDatas;
}
export function handlingCurrentDateTime(
  checkedCurrent: boolean,
  checkedBefore: boolean,
  autoUpadateChecked: boolean,
  horarioFinal,
  user
): string {
  if (checkedCurrent !== checkedBefore || autoUpadateChecked === true) {
    // pega data atual
    const date = GetDatePartCurrent();
    user.userPreference.Horario = date.fullDateFormat;
    setLocDatFinStorage(date.fullDateFormat);
    return date.fullDateFormat;
  }
  return horarioFinal;
}

export async function openTermo(user) {
  let arr = user.userPreference?.Country.CountryParameters;
  let urlTermo = arr?.filter(function (item) {
    return item.Dsc === "URL_TERMO";
  })[0].Val;
  window.open(urlTermo, "_blank", "noreferrer");
}

export async function openHelp(user) {
  let arr = user.userPreference?.Country.CountryParameters;
  let urlHelp = arr?.filter(function (item) {
    return item.Dsc === "URL_MANUAL";
  })[0].Val;
  window.open(urlHelp, "_blank", "noreferrer");
}

export function renderFaIconsFaSort(orderTypeOption: IChannelDataIconOption) {
  if (orderTypeOption.orderType === ChannelDataOrder.BySeq)
    return (
      <FaIcons.FaSortNumericDown title={orderTypeOption.titleOrderType0} />
    );

  if (orderTypeOption.orderType === ChannelDataOrder.ByLabel)
    return <FaIcons.FaSortAlphaDown title={orderTypeOption.titleOrderType1} />;
}
export function alertErroSaveEmissora(
  buttonChannel,
  setMsgError,
  setError,
  translation
) {
  if (buttonChannel === true) {
    let msgErro = translation("error.errorChangeColorChanelBeforeSave");
    setMsgError(msgErro);
    setError(true);
  }
}
export function emissoraColorClick(objParams) {
  objParams.setChannelColorSaved(true);
  objParams.setChannelButtonEdit(false);
  objParams.setButtonChannel(false);
  if (objParams.channelButtonEdit) {
    objParams.doChangeChannel();
  } else {
    objParams.doCancelChangeChannel();
  }
  setTimeout(() => {
    objParams.controlNavBar("emissoraColor");
  }, 2000);
}